import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';

const ThemeProvider = ({ children }) => {
    const theme = useSelector(state => state.organization.theme) || {};

    useEffect(() => {
        const { primary, secondary, text, action } = theme;

        const setGlobalStyle = (key, value) => {
            const root = document.documentElement;
            root.style.setProperty(key, value);
        }

        setGlobalStyle('--color-primary', primary.main);
        setGlobalStyle('--color-primary-light', primary.light);
        setGlobalStyle('--color-primary-lighter', primary.lighter);
        setGlobalStyle('--color-primary-dark', primary.dark);
        setGlobalStyle('--color-primary-darker', primary.darker);
        setGlobalStyle('--color-secondary', secondary.main);
        setGlobalStyle('--navbar-color', primary.main);
        setGlobalStyle('--text-primary', text.primary);
        setGlobalStyle('--text-secondary', text.secondary);
        setGlobalStyle('--text-active', action.active);

    }, [theme]);


    return (
        <React.Fragment>
            {children}
        </React.Fragment>
    )
}

export default ThemeProvider
